export var withAliases = function (component, properties) {
    return Object.assign(component, properties);
};
